// src/features/settlements/api.js
import api from "../../components/axiosComp";
const SUPER_ADMIN_SETTLEMENTS_BASE = "/api/superAdmin/settlements";
const VENUE_ADMIN_SETTLEMENTS_BASE = "/api/venue-admin/settlements";

const unwrapApiData = (data) => {
  if (data?.data && typeof data.data === "object") return data.data;
  return data;
};

// GET /settlements
export async function listSettlements(params = {}) {
  const { data } = await api.get("/api/settlements", { params });
  // normalize
  return {
    items: data?.items || [],
    page: data?.page || 1,
    limit: data?.limit || params.limit || 10,
    pages: data?.pages || 1,
    total: data?.total || 0,
  };
}

// GET /settlements/:id
export async function getSettlementById(id) {
  const { data } = await api.get(`/api/settlements/${id}`);
  return data;
}

// POST /settlements/calculate
export async function calculateSettlements(payload) {
  const { data } = await api.post("/api/settlements/calculate", payload);
  return data;
}

// PATCH /settlements/:id/settle
export async function settleSettlement(id, payload = {}) {
  const { data } = await api.patch(`/api/settlements/${id}/settle`, payload);
  return data;
}

// ===============================
// New settlement redesign APIs
// ===============================

// GET /api/superAdmin/settlements/dashboard
export async function getSettlementsDashboard(params = {}) {
  const { data } = await api.get(`${SUPER_ADMIN_SETTLEMENTS_BASE}/dashboard`, {
    params,
  });

  const payload = unwrapApiData(data);

  return {
    summary: payload?.summary || {},
    pending: payload?.pending || [],
    context: payload?.context || {},
    ok: data?.ok === true || payload?.ok === true,
  };
}

// GET /api/superAdmin/settlements/:id/review
export async function getSettlementReview(id, params = {}) {
  const { data } = await api.get(
    `${SUPER_ADMIN_SETTLEMENTS_BASE}/${id}/review`,
    { params }
  );

  return unwrapApiData(data);
}

// POST /api/superAdmin/settlements/:id/settle
export async function markSettlementSettled(id, payload = {}, params = {}) {
  const { data } = await api.post(
    `${SUPER_ADMIN_SETTLEMENTS_BASE}/${id}/settle`,
    payload,
    { params }
  );

  return data;
}

// GET /api/superAdmin/settlements/history
export async function getSettlementsHistory(params = {}) {
  const { data } = await api.get(`${SUPER_ADMIN_SETTLEMENTS_BASE}/history`, {
    params,
  });

  const payload = unwrapApiData(data);

  return {
    items: payload?.items || [],
    page: payload?.page || 1,
    limit: payload?.limit || params.limit || 20,
    pages: payload?.pages || 1,
    total: payload?.total || 0,
    summary: payload?.summary || {},
    context: payload?.context || {},
    ok: data?.ok === true || payload?.ok === true,
  };
}

// GET /api/superAdmin/settlements/history/export.csv
export async function exportSettlementsHistoryCsv(params = {}) {
  const response = await api.get(
    `${SUPER_ADMIN_SETTLEMENTS_BASE}/history/export.csv`,
    {
      params,
      responseType: "blob",
    }
  );

  const contentDisposition = response.headers?.["content-disposition"] || "";
  const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  const filename =
    filenameMatch?.[1] || `settlements-history-${new Date().toISOString().slice(0, 10)}.csv`;

  const blob = new Blob([response.data], {
    type: "text/csv;charset=utf-8;",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();

  link.remove();
  window.URL.revokeObjectURL(url);

  return { filename };
}

// GET /api/venue-admin/settlements/overview
export async function getVenueAdminSettlementOverview(params = {}) {
  const { data } = await api.get(
    `${VENUE_ADMIN_SETTLEMENTS_BASE}/overview`,
    { params }
  );

  return unwrapApiData(data);
}
